var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Event code","readonly":"","value":_vm.value,"outlined":"","append-icon":"mdi-content-copy","success-messages":_vm.successMessages,"error":_vm.copyToClipboardError},on:{"click:append":_vm.copyToClipboard}})}
var staticRenderFns = []

export { render, staticRenderFns }